var map = {
	"./Aircraft/Airliner_Black.png": 67,
	"./Aircraft/Airliner_Blue.png": 1035,
	"./Aircraft/Airliner_Green.png": 1036,
	"./Aircraft/Airliner_Grey.png": 1037,
	"./Aircraft/Airliner_Red.png": 1038,
	"./Aircraft/Airliner_Yellow.png": 1039,
	"./Aircraft/Airplane_Black.png": 1040,
	"./Aircraft/Airplane_Blue.png": 1041,
	"./Aircraft/Airplane_Green.png": 1042,
	"./Aircraft/Airplane_Grey.png": 1043,
	"./Aircraft/Airplane_Red.png": 1044,
	"./Aircraft/Airplane_Yellow.png": 1045,
	"./Aircraft/Helicopter_Black.png": 1046,
	"./Aircraft/Helicopter_Blue.png": 1047,
	"./Aircraft/Helicopter_Green.png": 1048,
	"./Aircraft/Helicopter_Grey.png": 1049,
	"./Aircraft/Helicopter_Red.png": 1050,
	"./Aircraft/Helicopter_Yellow.png": 1051,
	"./Arrows/093-chevron-1.png": 1052,
	"./Arrows/093-chevron-10.png": 1053,
	"./Arrows/093-chevron-11.png": 1054,
	"./Arrows/093-chevron-2.png": 1055,
	"./Arrows/093-chevron-3.png": 1056,
	"./Arrows/093-chevron-4.png": 1057,
	"./Arrows/093-chevron-5.png": 1058,
	"./Arrows/093-chevron-6.png": 1059,
	"./Arrows/093-chevron-7.png": 1060,
	"./Arrows/093-chevron-8.png": 1061,
	"./Arrows/093-chevron-9.png": 1062,
	"./Arrows/093-chevron.png": 1063,
	"./Arrows/093-compress-1.png": 1064,
	"./Arrows/093-compress.png": 1065,
	"./Arrows/093-curved-arrow-1.png": 1066,
	"./Arrows/093-curved-arrow-2.png": 1067,
	"./Arrows/093-curved-arrow-3.png": 1068,
	"./Arrows/093-curved-arrow.png": 1069,
	"./Arrows/093-diagonal-arrow-1.png": 1070,
	"./Arrows/093-diagonal-arrow-10.png": 1071,
	"./Arrows/093-diagonal-arrow-11.png": 1072,
	"./Arrows/093-diagonal-arrow-12.png": 1073,
	"./Arrows/093-diagonal-arrow-13.png": 1074,
	"./Arrows/093-diagonal-arrow-14.png": 1075,
	"./Arrows/093-diagonal-arrow-15.png": 1076,
	"./Arrows/093-diagonal-arrow-2.png": 1077,
	"./Arrows/093-diagonal-arrow-3.png": 1078,
	"./Arrows/093-diagonal-arrow-4.png": 1079,
	"./Arrows/093-diagonal-arrow-5.png": 1080,
	"./Arrows/093-diagonal-arrow-6.png": 1081,
	"./Arrows/093-diagonal-arrow-7.png": 1082,
	"./Arrows/093-diagonal-arrow-8.png": 1083,
	"./Arrows/093-diagonal-arrow-9.png": 1084,
	"./Arrows/093-diagonal-arrow.png": 1085,
	"./Arrows/093-down-arrow-1.png": 1086,
	"./Arrows/093-down-arrow-2.png": 1087,
	"./Arrows/093-down-arrow-3.png": 1088,
	"./Arrows/093-down-arrow-4.png": 1089,
	"./Arrows/093-down-arrow-5.png": 1090,
	"./Arrows/093-down-arrow.png": 1091,
	"./Arrows/093-exchange-1.png": 1092,
	"./Arrows/093-exchange.png": 1093,
	"./Arrows/093-expand-1.png": 1094,
	"./Arrows/093-expand-2.png": 1095,
	"./Arrows/093-expand-3.png": 1096,
	"./Arrows/093-expand.png": 1097,
	"./Arrows/093-left-arrow-1.png": 1098,
	"./Arrows/093-left-arrow-2.png": 1099,
	"./Arrows/093-left-arrow-3.png": 1100,
	"./Arrows/093-left-arrow-4.png": 1101,
	"./Arrows/093-left-arrow-5.png": 1102,
	"./Arrows/093-left-arrow-6.png": 1103,
	"./Arrows/093-left-arrow.png": 1104,
	"./Arrows/093-move-1.png": 1105,
	"./Arrows/093-move.png": 1106,
	"./Arrows/093-redo-1.png": 1107,
	"./Arrows/093-redo.png": 1108,
	"./Arrows/093-resize-1.png": 1109,
	"./Arrows/093-resize-2.png": 1110,
	"./Arrows/093-resize-3.png": 1111,
	"./Arrows/093-resize.png": 1112,
	"./Arrows/093-right-arrow-1.png": 1113,
	"./Arrows/093-right-arrow-2.png": 1114,
	"./Arrows/093-right-arrow-3.png": 1115,
	"./Arrows/093-right-arrow-4.png": 1116,
	"./Arrows/093-right-arrow-5.png": 1117,
	"./Arrows/093-right-arrow-6.png": 1118,
	"./Arrows/093-right-arrow-7.png": 1119,
	"./Arrows/093-right-arrow.png": 1120,
	"./Arrows/093-scroll-1.png": 1121,
	"./Arrows/093-scroll.png": 1122,
	"./Arrows/093-sort-1.png": 1123,
	"./Arrows/093-sort-2.png": 1124,
	"./Arrows/093-sort-3.png": 1125,
	"./Arrows/093-sort.png": 1126,
	"./Arrows/093-turn-left-1.png": 1127,
	"./Arrows/093-turn-left-2.png": 1128,
	"./Arrows/093-turn-left-3.png": 1129,
	"./Arrows/093-turn-left.png": 1130,
	"./Arrows/093-turn-right-1.png": 1131,
	"./Arrows/093-turn-right-2.png": 1132,
	"./Arrows/093-turn-right-3.png": 1133,
	"./Arrows/093-turn-right.png": 1134,
	"./Arrows/093-undo-1.png": 1135,
	"./Arrows/093-undo.png": 1136,
	"./Arrows/093-up-arrow-1.png": 1137,
	"./Arrows/093-up-arrow-2.png": 1138,
	"./Arrows/093-up-arrow-3.png": 1139,
	"./Arrows/093-up-arrow-4.png": 1140,
	"./Arrows/093-up-arrow-5.png": 1141,
	"./Arrows/093-up-arrow-6.png": 1142,
	"./Arrows/093-up-arrow.png": 1143,
	"./Assets/151-actions.png": 1144,
	"./Assets/151-advert.png": 1145,
	"./Assets/151-antennas.png": 1146,
	"./Assets/151-archives.png": 1147,
	"./Assets/151-attached.png": 1148,
	"./Assets/151-banker.png": 1149,
	"./Assets/151-barrow.png": 1150,
	"./Assets/151-bed-side.png": 1151,
	"./Assets/151-beds.png": 1152,
	"./Assets/151-blackboard.png": 1153,
	"./Assets/151-blocked.png": 1154,
	"./Assets/151-book-bag-1.png": 1155,
	"./Assets/151-book-bag.png": 1156,
	"./Assets/151-bridges.png": 1157,
	"./Assets/151-calculations.png": 1158,
	"./Assets/151-carrier.png": 1159,
	"./Assets/151-ceremonial.png": 1160,
	"./Assets/151-chairs.png": 1161,
	"./Assets/151-cleaned.png": 1162,
	"./Assets/151-closing.png": 1163,
	"./Assets/151-cooling.png": 1164,
	"./Assets/151-demostration.png": 1165,
	"./Assets/151-deposit.png": 1166,
	"./Assets/151-dialogue.png": 1167,
	"./Assets/151-disturbance.png": 1168,
	"./Assets/151-domestic-phone.png": 1169,
	"./Assets/151-door-key.png": 1170,
	"./Assets/151-door.png": 1171,
	"./Assets/151-doorway.png": 1172,
	"./Assets/151-draws.png": 1173,
	"./Assets/151-driller.png": 1174,
	"./Assets/151-electric-1.png": 1175,
	"./Assets/151-electric-2.png": 1176,
	"./Assets/151-electric.png": 1177,
	"./Assets/151-entrance.png": 1178,
	"./Assets/151-facade-1.png": 1179,
	"./Assets/151-facade.png": 1180,
	"./Assets/151-fader.png": 1181,
	"./Assets/151-file-storage.png": 1182,
	"./Assets/151-fireplace-1.png": 1183,
	"./Assets/151-fireplace.png": 1184,
	"./Assets/151-flats-1.png": 1185,
	"./Assets/151-flats.png": 1186,
	"./Assets/151-frame.png": 1187,
	"./Assets/151-garden-work.png": 1188,
	"./Assets/151-gardener.png": 1189,
	"./Assets/151-gardening.png": 1190,
	"./Assets/151-glamour.png": 1191,
	"./Assets/151-graphic-design.png": 1192,
	"./Assets/151-graphs.png": 1193,
	"./Assets/151-hacksaw.png": 1194,
	"./Assets/151-hand-gesture.png": 1195,
	"./Assets/151-hand-phones.png": 1196,
	"./Assets/151-headphones.png": 1197,
	"./Assets/151-health-care.png": 1198,
	"./Assets/151-hearth.png": 1199,
	"./Assets/151-house-things-1.png": 1200,
	"./Assets/151-house-things-2.png": 1201,
	"./Assets/151-house-things.png": 1202,
	"./Assets/151-house.png": 1203,
	"./Assets/151-houses.png": 1204,
	"./Assets/151-indoor.png": 1205,
	"./Assets/151-industrial-park.png": 1206,
	"./Assets/151-industrial.png": 1207,
	"./Assets/151-interior-design.png": 1208,
	"./Assets/151-invention.png": 1209,
	"./Assets/151-keyword.png": 1210,
	"./Assets/151-kilograms.png": 1211,
	"./Assets/151-ladders.png": 1212,
	"./Assets/151-line-chart.png": 1213,
	"./Assets/151-lover.png": 1214,
	"./Assets/151-mail.png": 1215,
	"./Assets/151-mailed.png": 1216,
	"./Assets/151-mallet.png": 1217,
	"./Assets/151-mansory.png": 1218,
	"./Assets/151-maps-and-flags-1.png": 1219,
	"./Assets/151-maps-and-flags-2.png": 1220,
	"./Assets/151-maps-and-flags-3.png": 1221,
	"./Assets/151-maps-and-flags-4.png": 1222,
	"./Assets/151-maps-and-flags-5.png": 1223,
	"./Assets/151-maps-and-flags-6.png": 1224,
	"./Assets/151-maps-and-flags.png": 1225,
	"./Assets/151-measuring-1.png": 1226,
	"./Assets/151-measuring.png": 1227,
	"./Assets/151-mechanics.png": 1228,
	"./Assets/151-metallic-blind.png": 1229,
	"./Assets/151-money-icons.png": 1230,
	"./Assets/151-monumental.png": 1231,
	"./Assets/151-motorhome.png": 1232,
	"./Assets/151-online-store.png": 1233,
	"./Assets/151-packaging.png": 1234,
	"./Assets/151-paint-roller.png": 1235,
	"./Assets/151-painted.png": 1236,
	"./Assets/151-paper-printer.png": 1237,
	"./Assets/151-paper-work.png": 1238,
	"./Assets/151-picket.png": 1239,
	"./Assets/151-pincers.png": 1240,
	"./Assets/151-plan.png": 1241,
	"./Assets/151-plans.png": 1242,
	"./Assets/151-plumbering-1.png": 1243,
	"./Assets/151-plumbering.png": 1244,
	"./Assets/151-printed.png": 1245,
	"./Assets/151-property.png": 1246,
	"./Assets/151-pruners.png": 1247,
	"./Assets/151-purses.png": 1248,
	"./Assets/151-radiators.png": 1249,
	"./Assets/151-reading-glasses.png": 1250,
	"./Assets/151-real-estate-1.png": 1251,
	"./Assets/151-real-estate-2.png": 1252,
	"./Assets/151-real-estate-3.png": 1253,
	"./Assets/151-real-estate-4.png": 1254,
	"./Assets/151-real-estate-5.png": 1255,
	"./Assets/151-real-estate-6.png": 1256,
	"./Assets/151-real-estate.png": 1257,
	"./Assets/151-relax.png": 1258,
	"./Assets/151-religious.png": 1259,
	"./Assets/151-rent.png": 1260,
	"./Assets/151-reparation.png": 1261,
	"./Assets/151-roof.png": 1262,
	"./Assets/151-sand-clock.png": 1263,
	"./Assets/151-savings.png": 1264,
	"./Assets/151-security-system-1.png": 1265,
	"./Assets/151-security-system.png": 1266,
	"./Assets/151-seventeen.png": 1267,
	"./Assets/151-shower.png": 1268,
	"./Assets/151-single.png": 1269,
	"./Assets/151-sit-down.png": 1270,
	"./Assets/151-skyline.png": 1271,
	"./Assets/151-step-ladder.png": 1272,
	"./Assets/151-storehouse.png": 1273,
	"./Assets/151-studying.png": 1274,
	"./Assets/151-switch-off.png": 1275,
	"./Assets/151-text-file.png": 1276,
	"./Assets/151-title.png": 1277,
	"./Assets/151-tools-and-utensils.png": 1278,
	"./Assets/151-transportation.png": 1279,
	"./Assets/151-trees.png": 1280,
	"./Assets/151-trucks-1.png": 1281,
	"./Assets/151-trucks.png": 1282,
	"./Assets/151-turned-off.png": 1283,
	"./Assets/151-up-1.png": 1284,
	"./Assets/151-up-2.png": 1285,
	"./Assets/151-up.png": 1286,
	"./Assets/151-ventilation.png": 1287,
	"./Assets/151-wc.png": 1288,
	"./Assets/151-wheel-chair.png": 1289,
	"./Assets/151-wheelbarrow.png": 1290,
	"./Assets/151-winch.png": 1291,
	"./Assets/151-work-tools.png": 1292,
	"./Assets/151-worker.png": 1293,
	"./Bikes/Bicycle_Black.png": 1294,
	"./Bikes/Bicycle_Blue.png": 1295,
	"./Bikes/Bicycle_Green.png": 1296,
	"./Bikes/Bicycle_Grey.png": 1297,
	"./Bikes/Bicycle_Red.png": 1298,
	"./Bikes/Bicycle_Yellow.png": 1299,
	"./Bikes/CruiserMotorcycle_Black.png": 1300,
	"./Bikes/CruiserMotorcycle_Blue.png": 1301,
	"./Bikes/CruiserMotorcycle_Green.png": 1302,
	"./Bikes/CruiserMotorcycle_Grey.png": 1303,
	"./Bikes/CruiserMotorcycle_Red.png": 1304,
	"./Bikes/CruiserMotorcycle_Yellow.png": 1305,
	"./Bikes/Motorcycle_Black.png": 1306,
	"./Bikes/Motorcycle_Blue.png": 1307,
	"./Bikes/Motorcycle_Green.png": 1308,
	"./Bikes/Motorcycle_Grey.png": 1309,
	"./Bikes/Motorcycle_Red.png": 1310,
	"./Bikes/Motorcycle_Yellow.png": 1311,
	"./Bikes/QuadBike_Black.png": 1312,
	"./Bikes/QuadBike_Blue.png": 1313,
	"./Bikes/QuadBike_Green.png": 1314,
	"./Bikes/QuadBike_Grey.png": 1315,
	"./Bikes/QuadBike_Red.png": 1316,
	"./Bikes/QuadBike_Yellow.png": 1317,
	"./Bikes/Scooter_Black.png": 1318,
	"./Bikes/Scooter_Blue.png": 1319,
	"./Bikes/Scooter_Green.png": 1320,
	"./Bikes/Scooter_Grey.png": 1321,
	"./Bikes/Scooter_Red.png": 1322,
	"./Bikes/Scooter_Yellow.png": 1323,
	"./Bikes/TouringMotorcycle_Black.png": 1324,
	"./Bikes/TouringMotorcycle_Blue.png": 1325,
	"./Bikes/TouringMotorcycle_Gray.png": 1326,
	"./Bikes/TouringMotorcycle_Green.png": 1327,
	"./Bikes/TouringMotorcycle_Red.png": 1328,
	"./Bikes/TouringMotorcycle_Yellow.png": 1329,
	"./Car/Cabriolet_Black.png": 1330,
	"./Car/Cabriolet_Blue.png": 1331,
	"./Car/Cabriolet_Green.png": 1332,
	"./Car/Cabriolet_Grey.png": 1333,
	"./Car/Cabriolet_Red.png": 1334,
	"./Car/Cabriolet_Yellow.png": 1335,
	"./Car/CamperVan_Black.png": 1336,
	"./Car/CamperVan_Blue.png": 1337,
	"./Car/CamperVan_Green.png": 1338,
	"./Car/CamperVan_Grey.png": 1339,
	"./Car/CamperVan_Red.png": 1340,
	"./Car/CamperVan_Yellow.png": 1341,
	"./Car/Car_Black.png": 1342,
	"./Car/Car_Blue.png": 1343,
	"./Car/Car_Green.png": 1344,
	"./Car/Car_Grey.png": 1345,
	"./Car/Car_Red.png": 1346,
	"./Car/Car_Yellow.png": 1347,
	"./Car/ExecutiveCar_Black.png": 1348,
	"./Car/ExecutiveCar_Blue.png": 1349,
	"./Car/ExecutiveCar_Green.png": 1350,
	"./Car/ExecutiveCar_Grey.png": 1351,
	"./Car/ExecutiveCar_Red.png": 1352,
	"./Car/ExecutiveCar_Yellow.png": 1353,
	"./Car/Hatchback_Black.png": 1354,
	"./Car/Hatchback_Blue.png": 1355,
	"./Car/Hatchback_Green.png": 1356,
	"./Car/Hatchback_Grey.png": 1357,
	"./Car/Hatchback_Red.png": 1358,
	"./Car/Hatchback_Yellow.png": 1359,
	"./Car/HybridCar_Black.png": 1360,
	"./Car/HybridCar_Blue.png": 1361,
	"./Car/HybridCar_Green.png": 1362,
	"./Car/HybridCar_Grey.png": 1363,
	"./Car/HybridCar_Red.png": 1364,
	"./Car/HybridCar_Yellow.png": 1365,
	"./Car/Jeep_Black.png": 1366,
	"./Car/Jeep_Blue.png": 1367,
	"./Car/Jeep_Green.png": 1368,
	"./Car/Jeep_Grey.png": 1369,
	"./Car/Jeep_Red.png": 1370,
	"./Car/Jeep_Yellow.png": 1371,
	"./Car/Limousine_Black.png": 1372,
	"./Car/Limousine_Blue.png": 1373,
	"./Car/Limousine_Green.png": 1374,
	"./Car/Limousine_Grey.png": 1375,
	"./Car/Limousine_Red.png": 1376,
	"./Car/Limousine_Yellow.png": 1377,
	"./Car/LuxuryCar__Black.png": 1378,
	"./Car/LuxuryCar__Blue.png": 1379,
	"./Car/LuxuryCar__Gray.png": 1380,
	"./Car/LuxuryCar__Green.png": 1381,
	"./Car/LuxuryCar__Red.png": 1382,
	"./Car/LuxuryCar__Yellow.png": 1383,
	"./Car/MUV_Black.png": 1384,
	"./Car/MUV_Blue.png": 1385,
	"./Car/MUV_Green.png": 1386,
	"./Car/MUV_Grey.png": 1387,
	"./Car/MUV_Red.png": 1388,
	"./Car/MUV_Yellow.png": 1389,
	"./Car/Minibus_Black.png": 1390,
	"./Car/Minibus_Blue.png": 1391,
	"./Car/Minibus_Green.png": 1392,
	"./Car/Minibus_Grey.png": 1393,
	"./Car/Minibus_Red.png": 1394,
	"./Car/Minibus_Yellow.png": 1395,
	"./Car/MinicarTrailer_Black.png": 1396,
	"./Car/MinicarTrailer_Blue.png": 1397,
	"./Car/MinicarTrailer_Green.png": 1398,
	"./Car/MinicarTrailer_Grey.png": 1399,
	"./Car/MinicarTrailer_Red.png": 1400,
	"./Car/MinicarTrailer_Yellow.png": 1401,
	"./Car/Minicar_Black.png": 1402,
	"./Car/Minicar_Blue.png": 1403,
	"./Car/Minicar_Green.png": 1404,
	"./Car/Minicar_Grey.png": 1405,
	"./Car/Minicar_Red.png": 1406,
	"./Car/Minicar_Yellow.png": 1407,
	"./Car/Minitruck_Black.png": 1408,
	"./Car/Minitruck_Blue.png": 1409,
	"./Car/Minitruck_Green.png": 1410,
	"./Car/Minitruck_Grey.png": 1411,
	"./Car/Minitruck_Red.png": 1412,
	"./Car/Minitruck_Yellow.png": 1413,
	"./Car/PanelVan_Black.png": 1414,
	"./Car/PanelVan_Blue.png": 1415,
	"./Car/PanelVan_Green.png": 1416,
	"./Car/PanelVan_Grey.png": 1417,
	"./Car/PanelVan_Red.png": 1418,
	"./Car/PanelVan_Yellow.png": 1419,
	"./Car/Pickup_Black.png": 1420,
	"./Car/Pickup_Blue.png": 1421,
	"./Car/Pickup_Green.png": 1422,
	"./Car/Pickup_Grey.png": 1423,
	"./Car/Pickup_Red.png": 1424,
	"./Car/Pickup_Yellow.png": 1425,
	"./Car/SUV_Black.png": 1426,
	"./Car/SUV_Blue.png": 1427,
	"./Car/SUV_Green.png": 1428,
	"./Car/SUV_Grey.png": 1429,
	"./Car/SUV_Red.png": 1430,
	"./Car/SUV_Yellow.png": 1431,
	"./Car/ServiceVan_Black.png": 1432,
	"./Car/ServiceVan_Blue.png": 1433,
	"./Car/ServiceVan_Green.png": 1434,
	"./Car/ServiceVan_Grey.png": 1435,
	"./Car/ServiceVan_Red.png": 1436,
	"./Car/ServiceVan_Yellow.png": 1437,
	"./Car/SportsCar_Black.png": 1438,
	"./Car/SportsCar_Blue.png": 1439,
	"./Car/SportsCar_Green.png": 1440,
	"./Car/SportsCar_Grey.png": 1441,
	"./Car/SportsCar_Red.png": 1442,
	"./Car/SportsCar_Yellow.png": 1443,
	"./Car/StationWagon_Black.png": 1444,
	"./Car/StationWagon_Blue.png": 1445,
	"./Car/StationWagon_Green.png": 1446,
	"./Car/StationWagon_Grey.png": 1447,
	"./Car/StationWagon_Red.png": 1448,
	"./Car/StationWagon_Yellow.png": 1449,
	"./Car/Van_Black.png": 1450,
	"./Car/Van_Blue.png": 1451,
	"./Car/Van_Green.png": 1452,
	"./Car/Van_Grey.png": 1453,
	"./Car/Van_Red.png": 1454,
	"./Car/Van_Yellow.png": 1455,
	"./Ecommerce/auction.png": 1456,
	"./Ecommerce/badge-1.png": 1457,
	"./Ecommerce/badge-2.png": 1458,
	"./Ecommerce/badge-3.png": 1459,
	"./Ecommerce/badge-4.png": 1460,
	"./Ecommerce/badge.png": 1461,
	"./Ecommerce/barcode.png": 1462,
	"./Ecommerce/bedside-table.png": 1463,
	"./Ecommerce/billing-machine.png": 1464,
	"./Ecommerce/browser-1.png": 1465,
	"./Ecommerce/browser.png": 1466,
	"./Ecommerce/calculator.png": 1467,
	"./Ecommerce/cash-register.png": 1468,
	"./Ecommerce/click.png": 1469,
	"./Ecommerce/clock.png": 1470,
	"./Ecommerce/closed.png": 1471,
	"./Ecommerce/coin-1.png": 1472,
	"./Ecommerce/coin-stack.png": 1473,
	"./Ecommerce/coin.png": 1474,
	"./Ecommerce/comments.png": 1475,
	"./Ecommerce/compact-disc.png": 1476,
	"./Ecommerce/cosmetics.png": 1477,
	"./Ecommerce/coupon.png": 1478,
	"./Ecommerce/credit-card-1.png": 1479,
	"./Ecommerce/credit-card-2.png": 1480,
	"./Ecommerce/credit-card.png": 1481,
	"./Ecommerce/customer-service.png": 1482,
	"./Ecommerce/delivery-cart.png": 1483,
	"./Ecommerce/delivery-truck-1.png": 1484,
	"./Ecommerce/delivery-truck.png": 1485,
	"./Ecommerce/diamond.png": 1486,
	"./Ecommerce/discount.png": 1487,
	"./Ecommerce/email.png": 1488,
	"./Ecommerce/faq.png": 1489,
	"./Ecommerce/gift-card.png": 1490,
	"./Ecommerce/gift.png": 1491,
	"./Ecommerce/groceries.png": 1492,
	"./Ecommerce/help.png": 1493,
	"./Ecommerce/like.png": 1494,
	"./Ecommerce/money-bag.png": 1495,
	"./Ecommerce/money.png": 1496,
	"./Ecommerce/monitor.png": 1497,
	"./Ecommerce/news.png": 1498,
	"./Ecommerce/notepad.png": 1499,
	"./Ecommerce/online-shop-1.png": 1500,
	"./Ecommerce/online-shop-2.png": 1501,
	"./Ecommerce/online-shop-3.png": 1502,
	"./Ecommerce/online-shop.png": 1503,
	"./Ecommerce/open.png": 1504,
	"./Ecommerce/order.png": 1505,
	"./Ecommerce/package-1.png": 1506,
	"./Ecommerce/package-2.png": 1507,
	"./Ecommerce/package-3.png": 1508,
	"./Ecommerce/package.png": 1509,
	"./Ecommerce/padlock.png": 1510,
	"./Ecommerce/piggy-bank.png": 1511,
	"./Ecommerce/placeholder.png": 1512,
	"./Ecommerce/price-tag.png": 1513,
	"./Ecommerce/promotion.png": 1514,
	"./Ecommerce/purse.png": 1515,
	"./Ecommerce/qr-code.png": 1516,
	"./Ecommerce/receipt.png": 1517,
	"./Ecommerce/refund.png": 1518,
	"./Ecommerce/return.png": 1519,
	"./Ecommerce/review.png": 1520,
	"./Ecommerce/rocket-ship.png": 1521,
	"./Ecommerce/safebox.png": 1522,
	"./Ecommerce/search-1.png": 1523,
	"./Ecommerce/search.png": 1524,
	"./Ecommerce/shield.png": 1525,
	"./Ecommerce/shirt-1.png": 1526,
	"./Ecommerce/shirt.png": 1527,
	"./Ecommerce/shopping-bag-1.png": 1528,
	"./Ecommerce/shopping-bag-2.png": 1529,
	"./Ecommerce/shopping-bag.png": 1530,
	"./Ecommerce/shopping-basket-1.png": 1531,
	"./Ecommerce/shopping-basket-2.png": 1532,
	"./Ecommerce/shopping-basket-3.png": 1533,
	"./Ecommerce/shopping-basket-4.png": 1534,
	"./Ecommerce/shopping-basket.png": 1535,
	"./Ecommerce/shopping-cart-1.png": 1536,
	"./Ecommerce/shopping-cart-2.png": 1537,
	"./Ecommerce/shopping-cart-3.png": 1538,
	"./Ecommerce/shopping-cart-4.png": 1539,
	"./Ecommerce/shopping-cart.png": 1540,
	"./Ecommerce/smartphone-1.png": 1541,
	"./Ecommerce/smartphone.png": 1542,
	"./Ecommerce/star.png": 1543,
	"./Ecommerce/statistics.png": 1544,
	"./Ecommerce/stock-1.png": 1545,
	"./Ecommerce/stock-2.png": 1546,
	"./Ecommerce/stock.png": 1547,
	"./Ecommerce/stopwatch.png": 1548,
	"./Ecommerce/store.png": 1549,
	"./Ecommerce/survey.png": 1550,
	"./Ecommerce/user.png": 1551,
	"./Ecommerce/wallet.png": 1552,
	"./Ecommerce/wishlist-1.png": 1553,
	"./Ecommerce/wishlist.png": 1554,
	"./Ecommerce/worldwide.png": 1555,
	"./Emergencies/001-air-pump.png": 1556,
	"./Emergencies/002-helicopter.png": 1557,
	"./Emergencies/003-defibrillator.png": 1558,
	"./Emergencies/004-toolbox.png": 1559,
	"./Emergencies/005-smartphone.png": 1560,
	"./Emergencies/006-heart.png": 1561,
	"./Emergencies/007-hospital-2.png": 1562,
	"./Emergencies/008-tools.png": 1563,
	"./Emergencies/009-caution.png": 1564,
	"./Emergencies/010-hospital-1.png": 1565,
	"./Emergencies/011-pin.png": 1566,
	"./Emergencies/012-blood-transfusion.png": 1567,
	"./Emergencies/013-firefighter-1.png": 1568,
	"./Emergencies/014-barrier.png": 1569,
	"./Emergencies/015-fire-truck.png": 1570,
	"./Emergencies/016-police-badge.png": 1571,
	"./Emergencies/017-hospital.png": 1572,
	"./Emergencies/018-bucket.png": 1573,
	"./Emergencies/019-smoke-detector.png": 1574,
	"./Emergencies/020-shovel.png": 1575,
	"./Emergencies/021-walkie-talkie.png": 1576,
	"./Emergencies/022-firefighter.png": 1577,
	"./Emergencies/023-stretcher.png": 1578,
	"./Emergencies/024-lifebuoy.png": 1579,
	"./Emergencies/025-fire-extinguisher.png": 1580,
	"./Emergencies/026-warning.png": 1581,
	"./Emergencies/027-hydrant.png": 1582,
	"./Emergencies/028-matches.png": 1583,
	"./Emergencies/029-phone-call.png": 1584,
	"./Emergencies/030-life-jacket.png": 1585,
	"./Emergencies/031-band-aid.png": 1586,
	"./Emergencies/032-lighter.png": 1587,
	"./Emergencies/033-megaphone.png": 1588,
	"./Emergencies/034-sos.png": 1589,
	"./Emergencies/035-whistle.png": 1590,
	"./Emergencies/036-flashlight.png": 1591,
	"./Emergencies/037-sprinkler.png": 1592,
	"./Emergencies/038-fire-alarm-1.png": 1593,
	"./Emergencies/039-gas-mask.png": 1594,
	"./Emergencies/040-ambulance.png": 1595,
	"./Emergencies/041-emergency-call.png": 1596,
	"./Emergencies/042-first-aid-kit.png": 1597,
	"./Emergencies/043-fire.png": 1598,
	"./Emergencies/044-hose.png": 1599,
	"./Emergencies/045-exit.png": 1600,
	"./Emergencies/046-axe.png": 1601,
	"./Emergencies/047-cone.png": 1602,
	"./Emergencies/048-ladder.png": 1603,
	"./Emergencies/049-siren.png": 1604,
	"./Emergencies/050-fire-alarm.png": 1605,
	"./Family/001-couple-3.png": 1606,
	"./Family/002-house.png": 1607,
	"./Family/003-stroller.png": 1608,
	"./Family/004-son.png": 1609,
	"./Family/005-suitcase.png": 1610,
	"./Family/006-family-2.png": 1611,
	"./Family/007-pet-house.png": 1612,
	"./Family/008-cups.png": 1613,
	"./Family/009-photo-album.png": 1614,
	"./Family/010-fireplace.png": 1615,
	"./Family/011-pin.png": 1616,
	"./Family/012-insurance.png": 1617,
	"./Family/013-swing.png": 1618,
	"./Family/014-sofa.png": 1619,
	"./Family/015-couple-2.png": 1620,
	"./Family/016-home-1.png": 1621,
	"./Family/017-daughter.png": 1622,
	"./Family/018-gift-1.png": 1623,
	"./Family/019-shopping-basket.png": 1624,
	"./Family/020-television.png": 1625,
	"./Family/021-divorce.png": 1626,
	"./Family/022-picture-1.png": 1627,
	"./Family/023-briefcase.png": 1628,
	"./Family/024-graduate.png": 1629,
	"./Family/025-pacifier.png": 1630,
	"./Family/026-beach-ball.png": 1631,
	"./Family/027-love.png": 1632,
	"./Family/028-couple-1.png": 1633,
	"./Family/029-couple.png": 1634,
	"./Family/030-scooter.png": 1635,
	"./Family/031-gift.png": 1636,
	"./Family/032-picture.png": 1637,
	"./Family/033-wedding-rings.png": 1638,
	"./Family/034-wedding-cake.png": 1639,
	"./Family/035-newlyweds.png": 1640,
	"./Family/036-grave.png": 1641,
	"./Family/037-crib.png": 1642,
	"./Family/038-cat.png": 1643,
	"./Family/039-father.png": 1644,
	"./Family/040-dog.png": 1645,
	"./Family/041-care.png": 1646,
	"./Family/042-family-1.png": 1647,
	"./Family/043-grandparents.png": 1648,
	"./Family/044-family.png": 1649,
	"./Family/045-home.png": 1650,
	"./Family/046-motherhood.png": 1651,
	"./Family/047-grandfather.png": 1652,
	"./Family/048-grandmother.png": 1653,
	"./Family/049-newborn.png": 1654,
	"./Family/050-mother.png": 1655,
	"./GPS/compass-1.png": 1656,
	"./GPS/compass.png": 1657,
	"./GPS/gps.png": 1658,
	"./GPS/location-1.png": 1659,
	"./GPS/location-2.png": 1660,
	"./GPS/location-3.png": 1661,
	"./GPS/location.png": 145,
	"./GPS/location3.png": 1662,
	"./GPS/location_green.svg": 301,
	"./GPS/locations.png": 1663,
	"./GPS/map-1.png": 1664,
	"./GPS/map-2.png": 1665,
	"./GPS/map-3.png": 1666,
	"./GPS/map.png": 1667,
	"./GPS/navigator.png": 1668,
	"./GPS/panel.png": 1669,
	"./GPS/pin.png": 1670,
	"./GPS/placeholder-1.png": 1671,
	"./GPS/placeholder-2.png": 1672,
	"./GPS/placeholder-3.png": 1673,
	"./GPS/placeholder-4.png": 1674,
	"./GPS/placeholder-5.png": 1675,
	"./GPS/placeholder-6.png": 1676,
	"./GPS/placeholder-7.png": 1677,
	"./GPS/placeholder.png": 63,
	"./GPS/push-pin.png": 1678,
	"./GPS/route-1.png": 1679,
	"./GPS/route.png": 1680,
	"./GPS/satellite.png": 1681,
	"./GPS/selectLocation.svg": 143,
	"./GPS/smartphone-1.png": 1682,
	"./GPS/smartphone.png": 1683,
	"./GPS/target.png": 1684,
	"./Home/alarm-clock.png": 1685,
	"./Home/alcoholic-1.png": 1686,
	"./Home/alcoholic.png": 1687,
	"./Home/bake.png": 1688,
	"./Home/bathing.png": 1689,
	"./Home/bedroom-1.png": 1690,
	"./Home/bedroom-2.png": 1691,
	"./Home/bedroom-3.png": 1692,
	"./Home/bedroom-4.png": 1693,
	"./Home/bedroom-5.png": 1694,
	"./Home/bedroom-6.png": 1695,
	"./Home/bedroom.png": 1696,
	"./Home/bookcase.png": 1697,
	"./Home/carpenter.png": 1698,
	"./Home/carpet.png": 1699,
	"./Home/chairs-1.png": 1700,
	"./Home/chairs-2.png": 1701,
	"./Home/chairs.png": 1702,
	"./Home/chinese-food.png": 1703,
	"./Home/coffee-cup-1.png": 1704,
	"./Home/coffee-cup-2.png": 1705,
	"./Home/coffee-shop.png": 1706,
	"./Home/coffees.png": 1707,
	"./Home/comfortable-1.png": 1708,
	"./Home/comfortable.png": 1709,
	"./Home/coolnes.png": 1710,
	"./Home/couch.png": 1711,
	"./Home/door-key.png": 1712,
	"./Home/drinking.png": 1713,
	"./Home/elegant.png": 1714,
	"./Home/firefighting.png": 1715,
	"./Home/fry.png": 1716,
	"./Home/game-console.png": 1717,
	"./Home/garbage-bin.png": 1718,
	"./Home/gardening.png": 1719,
	"./Home/hair-salon.png": 1720,
	"./Home/hangers.png": 1721,
	"./Home/home-repair.png": 1722,
	"./Home/hot-drink.png": 1723,
	"./Home/hygienic-1.png": 1724,
	"./Home/hygienic.png": 1725,
	"./Home/invention.png": 1726,
	"./Home/japanese-food.png": 1727,
	"./Home/kitchen-pack-1.png": 1728,
	"./Home/kitchen-pack-10.png": 1729,
	"./Home/kitchen-pack-11.png": 1730,
	"./Home/kitchen-pack-12.png": 1731,
	"./Home/kitchen-pack-13.png": 1732,
	"./Home/kitchen-pack-14.png": 1733,
	"./Home/kitchen-pack-15.png": 1734,
	"./Home/kitchen-pack-16.png": 1735,
	"./Home/kitchen-pack-2.png": 1736,
	"./Home/kitchen-pack-3.png": 1737,
	"./Home/kitchen-pack-4.png": 1738,
	"./Home/kitchen-pack-5.png": 1739,
	"./Home/kitchen-pack-6.png": 1740,
	"./Home/kitchen-pack-7.png": 1741,
	"./Home/kitchen-pack-8.png": 1742,
	"./Home/kitchen-pack-9.png": 1743,
	"./Home/kitchen-pack.png": 1744,
	"./Home/kitchen-tools.png": 1745,
	"./Home/laptop-computer.png": 1746,
	"./Home/livingroom-1.png": 1747,
	"./Home/livingroom-2.png": 1748,
	"./Home/livingroom.png": 1749,
	"./Home/passkey.png": 1750,
	"./Home/phone-call.png": 1751,
	"./Home/phone-receiver.png": 1752,
	"./Home/plugging-1.png": 1753,
	"./Home/plugging.png": 1754,
	"./Home/protein.png": 1755,
	"./Home/real-estate-1.png": 1756,
	"./Home/real-estate-2.png": 1757,
	"./Home/real-estate-3.png": 1758,
	"./Home/real-estate.png": 1759,
	"./Home/reflecting.png": 1760,
	"./Home/refreshment.png": 1761,
	"./Home/restauran.png": 1762,
	"./Home/restroom.png": 1763,
	"./Home/seat.png": 1764,
	"./Home/seatting.png": 1765,
	"./Home/showers.png": 1766,
	"./Home/sinks.png": 1767,
	"./Home/sleepy.png": 1768,
	"./Home/studying-1.png": 1769,
	"./Home/studying-2.png": 1770,
	"./Home/studying.png": 1771,
	"./Home/supper.png": 1772,
	"./Home/technological.png": 1773,
	"./Home/televisions-1.png": 1774,
	"./Home/televisions.png": 1775,
	"./Home/ventilator.png": 1776,
	"./Home/wooden-chair.png": 1777,
	"./Home/yard.png": 1778,
	"./Hospital/ambulance.png": 1779,
	"./Hospital/band-aid.png": 1780,
	"./Hospital/bandage.png": 1781,
	"./Hospital/blood-donation.png": 1782,
	"./Hospital/blood-sample.png": 1783,
	"./Hospital/blood-transfusion.png": 1784,
	"./Hospital/broken-bone.png": 1785,
	"./Hospital/cardiogram.png": 1786,
	"./Hospital/clinic-history.png": 1787,
	"./Hospital/coffee-cup.png": 1788,
	"./Hospital/crutches.png": 1789,
	"./Hospital/dna.png": 1790,
	"./Hospital/doctor.png": 1791,
	"./Hospital/dropper.png": 1792,
	"./Hospital/electrocardiogram.png": 1793,
	"./Hospital/eye-drops.png": 1794,
	"./Hospital/eye.png": 1795,
	"./Hospital/first-aid-kit.png": 1796,
	"./Hospital/flask.png": 1797,
	"./Hospital/hospital-1.png": 1798,
	"./Hospital/hospital-2.png": 1799,
	"./Hospital/hospital-bed.png": 1800,
	"./Hospital/hospital.png": 1801,
	"./Hospital/id-card.png": 1802,
	"./Hospital/laptop.png": 1803,
	"./Hospital/mask.png": 1804,
	"./Hospital/medicine-1.png": 1805,
	"./Hospital/medicine-2.png": 1806,
	"./Hospital/medicine-3.png": 1807,
	"./Hospital/medicine-4.png": 1808,
	"./Hospital/medicine.png": 1809,
	"./Hospital/microscope.png": 1810,
	"./Hospital/nurse.png": 1811,
	"./Hospital/optometry.png": 1812,
	"./Hospital/pill.png": 1813,
	"./Hospital/pills-1.png": 1814,
	"./Hospital/pills.png": 1815,
	"./Hospital/placeholder.png": 1816,
	"./Hospital/prescription.png": 1817,
	"./Hospital/serum.png": 1818,
	"./Hospital/shirt.png": 1819,
	"./Hospital/smartphone.png": 1820,
	"./Hospital/stethoscope.png": 1821,
	"./Hospital/tag.png": 1822,
	"./Hospital/test-tube.png": 1823,
	"./Hospital/thermometer.png": 1824,
	"./Hospital/tooth.png": 1825,
	"./Hospital/vaccine.png": 1826,
	"./Hospital/virus.png": 1827,
	"./Hospital/weight.png": 1828,
	"./Lights/amber_light.png": 1829,
	"./Lights/green_light.png": 1830,
	"./Lights/grey_light.png": 1831,
	"./Lights/red_light.png": 1832,
	"./Lights/traffic_light_green.png": 1833,
	"./Lights/traffic_light_none.png": 1834,
	"./Lights/traffic_light_red.png": 1835,
	"./Lights/trafficlight.png": 1836,
	"./Lights/trafficlightcolour.png": 1837,
	"./Logistics/001-distribution-5.png": 1838,
	"./Logistics/002-aerial.png": 1839,
	"./Logistics/003-frontal-view.png": 1840,
	"./Logistics/004-distribution-4.png": 1841,
	"./Logistics/005-clipboards.png": 1842,
	"./Logistics/006-oceanic.png": 1843,
	"./Logistics/007-placeholders-1.png": 1844,
	"./Logistics/008-international.png": 1845,
	"./Logistics/009-packages-2.png": 1846,
	"./Logistics/010-tools-and-utensils-3.png": 1847,
	"./Logistics/011-weekly-calendar.png": 1848,
	"./Logistics/012-placeholders.png": 1849,
	"./Logistics/013-distribution-3.png": 1850,
	"./Logistics/014-shopping-carts-1.png": 1851,
	"./Logistics/015-maps-and-flags-1.png": 1852,
	"./Logistics/016-organizing.png": 1853,
	"./Logistics/017-maps-and-flags.png": 1854,
	"./Logistics/018-tools-and-utensils-2.png": 1855,
	"./Logistics/019-call-center-1.png": 1856,
	"./Logistics/020-protected.png": 1857,
	"./Logistics/021-cubes.png": 1858,
	"./Logistics/022-distribution-2.png": 1859,
	"./Logistics/023-call-center.png": 1860,
	"./Logistics/024-bussiness.png": 1861,
	"./Logistics/025-charter.png": 1862,
	"./Logistics/026-trolley-cart.png": 1863,
	"./Logistics/027-distribution-1.png": 1864,
	"./Logistics/028-tools-and-utensils-1.png": 1865,
	"./Logistics/029-airplanes.png": 1866,
	"./Logistics/030-verified.png": 1867,
	"./Logistics/031-shopping-carts.png": 1868,
	"./Logistics/032-transportation.png": 1869,
	"./Logistics/033-packages-1.png": 1870,
	"./Logistics/034-changing.png": 1871,
	"./Logistics/035-packages.png": 1872,
	"./Logistics/036-symbolic.png": 1873,
	"./Logistics/037-packing.png": 1874,
	"./Logistics/038-trucks.png": 1875,
	"./Logistics/039-tools-and-utensils.png": 1876,
	"./Logistics/040-circular-arrows.png": 1877,
	"./Logistics/041-debit-card.png": 1878,
	"./Logistics/042-24-hours.png": 1879,
	"./Logistics/043-distribution.png": 1880,
	"./Logistics/044-cargo-ship.png": 1881,
	"./Machinery/BackhoeLoader_Black.png": 1882,
	"./Machinery/BackhoeLoader_Blue.png": 1883,
	"./Machinery/BackhoeLoader_Green.png": 1884,
	"./Machinery/BackhoeLoader_Grey.png": 1885,
	"./Machinery/BackhoeLoader_Red.png": 1886,
	"./Machinery/BackhoeLoader_Yellow.png": 1887,
	"./Machinery/Bulldozer_Black.png": 1888,
	"./Machinery/Bulldozer_Blue.png": 1889,
	"./Machinery/Bulldozer_Green.png": 1890,
	"./Machinery/Bulldozer_Grey.png": 1891,
	"./Machinery/Bulldozer_Red.png": 1892,
	"./Machinery/Bulldozer_Yellow.png": 1893,
	"./Machinery/CompactExcavator_Black.png": 1894,
	"./Machinery/CompactExcavator_Blue.png": 1895,
	"./Machinery/CompactExcavator_Green.png": 1896,
	"./Machinery/CompactExcavator_Grey.png": 1897,
	"./Machinery/CompactExcavator_Red.png": 1898,
	"./Machinery/CompactExcavator_Yellow.png": 1899,
	"./Machinery/Excavator_Black.png": 1900,
	"./Machinery/Excavator_Blue.png": 1901,
	"./Machinery/Excavator_Green.png": 1902,
	"./Machinery/Excavator_Grey.png": 1903,
	"./Machinery/Excavator_Red.png": 1904,
	"./Machinery/Excavator_Yellow.png": 1905,
	"./Machinery/FarmTractor_Black.png": 1906,
	"./Machinery/FarmTractor_Blue.png": 1907,
	"./Machinery/FarmTractor_Green.png": 1908,
	"./Machinery/FarmTractor_Grey.png": 1909,
	"./Machinery/FarmTractor_Red.png": 1910,
	"./Machinery/FarmTractor_Yellow.png": 1911,
	"./Machinery/ForkliftTruck_Loaded_Black.png": 1912,
	"./Machinery/ForkliftTruck_Loaded_Blue.png": 1913,
	"./Machinery/ForkliftTruck_Loaded_Green.png": 1914,
	"./Machinery/ForkliftTruck_Loaded_Grey.png": 1915,
	"./Machinery/ForkliftTruck_Loaded_Red.png": 1916,
	"./Machinery/ForkliftTruck_Loaded_Yellow.png": 1917,
	"./Machinery/ForkliftTruck__Black.png": 1918,
	"./Machinery/ForkliftTruck__Blue.png": 1919,
	"./Machinery/ForkliftTruck__Green.png": 1920,
	"./Machinery/ForkliftTruck__Grey.png": 1921,
	"./Machinery/ForkliftTruck__Red.png": 1922,
	"./Machinery/ForkliftTruck__Yellow.png": 1923,
	"./Machinery/LandfillCompactor_Black.png": 1924,
	"./Machinery/LandfillCompactor_Blue.png": 1925,
	"./Machinery/LandfillCompactor_Green.png": 1926,
	"./Machinery/LandfillCompactor_Grey.png": 1927,
	"./Machinery/LandfillCompactor_Red.png": 1928,
	"./Machinery/LandfillCompactor_Yellow.png": 1929,
	"./Machinery/Loader_Black.png": 1930,
	"./Machinery/Loader_Blue.png": 1931,
	"./Machinery/Loader_Green.png": 1932,
	"./Machinery/Loader_Grey.png": 1933,
	"./Machinery/Loader_Red.png": 1934,
	"./Machinery/Loader_Yellow.png": 1935,
	"./Machinery/MaterialHandler_Black.png": 1936,
	"./Machinery/MaterialHandler_Blue.png": 1937,
	"./Machinery/MaterialHandler_Green.png": 1938,
	"./Machinery/MaterialHandler_Grey.png": 1939,
	"./Machinery/MaterialHandler_Red.png": 1940,
	"./Machinery/MaterialHandler_Yellow.png": 1941,
	"./Machinery/RoadRoller_Black.png": 1942,
	"./Machinery/RoadRoller_Blue.png": 1943,
	"./Machinery/RoadRoller_Green.png": 1944,
	"./Machinery/RoadRoller_Grey.png": 1945,
	"./Machinery/RoadRoller_Red.png": 1946,
	"./Machinery/RoadRoller_Yellow.png": 1947,
	"./Machinery/RoadSweeper_Black.png": 1948,
	"./Machinery/RoadSweeper_Blue.png": 1949,
	"./Machinery/RoadSweeper_Green.png": 1950,
	"./Machinery/RoadSweeper_Grey.png": 1951,
	"./Machinery/RoadSweeper_Red.png": 1952,
	"./Machinery/RoadSweeper_Yellow.png": 1953,
	"./Machinery/RollerCompactor_Black.png": 1954,
	"./Machinery/RollerCompactor_Blue.png": 1955,
	"./Machinery/RollerCompactor_Green.png": 1956,
	"./Machinery/RollerCompactor_Grey.png": 1957,
	"./Machinery/RollerCompactor_Red.png": 1958,
	"./Machinery/RollerCompactor_Yellow.png": 1959,
	"./Machinery/SkidSteerLoader_Black.png": 1960,
	"./Machinery/SkidSteerLoader_Blue.png": 1961,
	"./Machinery/SkidSteerLoader_Green.png": 1962,
	"./Machinery/SkidSteerLoader_Grey.png": 1963,
	"./Machinery/SkidSteerLoader_Red.png": 1964,
	"./Machinery/SkidSteerLoader_Yellow.png": 1965,
	"./Machinery/SkipLoader_Black.png": 1966,
	"./Machinery/SkipLoader_Blue.png": 1967,
	"./Machinery/SkipLoader_Green.png": 1968,
	"./Machinery/SkipLoader_Grey.png": 1969,
	"./Machinery/SkipLoader_Red.png": 1970,
	"./Machinery/SkipLoader_Yellow.png": 1971,
	"./Machinery/SoilStabilizer_Black.png": 1972,
	"./Machinery/SoilStabilizer_Blue.png": 1973,
	"./Machinery/SoilStabilizer_Green.png": 1974,
	"./Machinery/SoilStabilizer_Grey.png": 1975,
	"./Machinery/SoilStabilizer_Red.png": 1976,
	"./Machinery/SoilStabilizer_Yellow.png": 1977,
	"./Machinery/SteamRoller_Black.png": 1978,
	"./Machinery/SteamRoller_Blue.png": 1979,
	"./Machinery/SteamRoller_Green.png": 1980,
	"./Machinery/SteamRoller_Grey.png": 1981,
	"./Machinery/SteamRoller_Red.png": 1982,
	"./Machinery/SteamRoller_Yellow.png": 1983,
	"./Machinery/StreetSweeper_Black.png": 1984,
	"./Machinery/StreetSweeper_Blue.png": 1985,
	"./Machinery/StreetSweeper_Green.png": 1986,
	"./Machinery/StreetSweeper_Grey.png": 1987,
	"./Machinery/StreetSweeper_Red.png": 1988,
	"./Machinery/StreetSweeper_Yellow.png": 1989,
	"./Machinery/TelescopicHandler_Black.png": 1990,
	"./Machinery/TelescopicHandler_Blue.png": 1991,
	"./Machinery/TelescopicHandler_Green.png": 1992,
	"./Machinery/TelescopicHandler_Grey.png": 1993,
	"./Machinery/TelescopicHandler_Red.png": 1994,
	"./Machinery/TelescopicHandler_Yellow.png": 1995,
	"./Machinery/TruckMountedCrane_Working_Black.png": 1996,
	"./Machinery/TruckMountedCrane_Working_Blue.png": 1997,
	"./Machinery/TruckMountedCrane_Working_Green.png": 1998,
	"./Machinery/TruckMountedCrane_Working_Grey.png": 1999,
	"./Machinery/TruckMountedCrane_Working_Red.png": 2000,
	"./Machinery/TruckMountedCrane_Working_Yellow.png": 2001,
	"./Machinery/TruckMountedCrane__Black.png": 2002,
	"./Machinery/TruckMountedCrane__Blue.png": 2003,
	"./Machinery/TruckMountedCrane__Green.png": 2004,
	"./Machinery/TruckMountedCrane__Grey.png": 2005,
	"./Machinery/TruckMountedCrane__Red.png": 2006,
	"./Machinery/TruckMountedCrane__Yellow.png": 2007,
	"./Machinery/WheeledExcavator_Black.png": 2008,
	"./Machinery/WheeledExcavator_Blue.png": 2009,
	"./Machinery/WheeledExcavator_Green.png": 2010,
	"./Machinery/WheeledExcavator_Grey.png": 2011,
	"./Machinery/WheeledExcavator_Red.png": 2012,
	"./Machinery/WheeledExcavator_Yellow.png": 2013,
	"./Machinery/WreckingBall_Black.png": 2014,
	"./Machinery/WreckingBall_Blue.png": 2015,
	"./Machinery/WreckingBall_Green.png": 2016,
	"./Machinery/WreckingBall_Grey.png": 2017,
	"./Machinery/WreckingBall_Red.png": 2018,
	"./Machinery/WreckingBall_Yellow.png": 2019,
	"./Marine/001-pirate-3.png": 2020,
	"./Marine/001-whale.png": 2021,
	"./Marine/002-hook.png": 2022,
	"./Marine/002-lifesaver.png": 2023,
	"./Marine/003-round-shot.png": 2024,
	"./Marine/003-sailor-cap-2.png": 2025,
	"./Marine/004-anchor-2.png": 2026,
	"./Marine/004-starfish.png": 2027,
	"./Marine/005-anchor-1.png": 2028,
	"./Marine/005-cannon.png": 2029,
	"./Marine/006-dolphin.png": 2030,
	"./Marine/006-parrot.png": 2031,
	"./Marine/007-island.png": 2032,
	"./Marine/007-knot-1.png": 2033,
	"./Marine/008-pirate-2.png": 2034,
	"./Marine/008-sailor-cap-1.png": 2035,
	"./Marine/009-flag.png": 2036,
	"./Marine/009-key.png": 2037,
	"./Marine/010-barrel.png": 2038,
	"./Marine/010-seagull-1.png": 2039,
	"./Marine/011-boat.png": 2040,
	"./Marine/011-paddle.png": 2041,
	"./Marine/012-pirate-ship.png": 2042,
	"./Marine/012-porthole.png": 2043,
	"./Marine/013-bollard.png": 2044,
	"./Marine/013-gold-ingots.png": 2045,
	"./Marine/014-lighthouse-1.png": 2046,
	"./Marine/014-placeholder.png": 2047,
	"./Marine/015-buoys.png": 2048,
	"./Marine/015-skull-and-bones.png": 2049,
	"./Marine/016-flippers.png": 2050,
	"./Marine/016-sword.png": 2051,
	"./Marine/017-pirate-1.png": 2052,
	"./Marine/017-shirt.png": 2053,
	"./Marine/018-chains.png": 2054,
	"./Marine/018-pipe.png": 2055,
	"./Marine/019-eyepatch.png": 2056,
	"./Marine/019-pipe-1.png": 2057,
	"./Marine/020-compass-2.png": 2058,
	"./Marine/020-gallows.png": 2059,
	"./Marine/021-coin.png": 2060,
	"./Marine/021-radar-1.png": 2061,
	"./Marine/022-compass-1.png": 2062,
	"./Marine/022-rum.png": 2063,
	"./Marine/023-money-bag.png": 2064,
	"./Marine/023-radar.png": 2065,
	"./Marine/024-diving-helmet.png": 2066,
	"./Marine/024-pirate.png": 2067,
	"./Marine/025-bottle.png": 2068,
	"./Marine/025-treasure-map.png": 2069,
	"./Marine/026-captain.png": 2070,
	"./Marine/026-wooden-leg.png": 2071,
	"./Marine/027-helm.png": 2072,
	"./Marine/027-yatch.png": 2073,
	"./Marine/028-message-in-a-bottle.png": 2074,
	"./Marine/028-oars.png": 2075,
	"./Marine/029-lighthouse.png": 2076,
	"./Marine/029-ship.png": 2077,
	"./Marine/030-binoculars.png": 2078,
	"./Marine/030-torch.png": 2079,
	"./Marine/031-jolly-roger.png": 2080,
	"./Marine/031-propeller.png": 2081,
	"./Marine/032-bell.png": 2082,
	"./Marine/032-hook.png": 2083,
	"./Marine/033-dice.png": 2084,
	"./Marine/033-map.png": 2085,
	"./Marine/034-sailor-cap.png": 2086,
	"./Marine/034-telescope.png": 2087,
	"./Marine/035-knot.png": 2088,
	"./Marine/035-tortoise.png": 2089,
	"./Marine/036-letter.png": 2090,
	"./Marine/036-waves.png": 2091,
	"./Marine/037-anchor.png": 2092,
	"./Marine/037-pipe.png": 2093,
	"./Marine/038-compass.png": 2094,
	"./Marine/038-lifebuoy.png": 2095,
	"./Marine/039-bomb.png": 2096,
	"./Marine/039-rudder-1.png": 2097,
	"./Marine/040-sailboat.png": 2098,
	"./Marine/040-treasure.png": 2099,
	"./Marine/041-starfish.png": 2100,
	"./Marine/042-lighthouse.png": 2101,
	"./Marine/043-spyglass.png": 2102,
	"./Marine/044-fish.png": 2103,
	"./Marine/045-compass.png": 2104,
	"./Marine/046-anchor.png": 2105,
	"./Marine/047-seagull.png": 2106,
	"./Marine/048-rudder.png": 2107,
	"./Marine/049-snorkel.png": 2108,
	"./Marine/050-life-jacket.png": 2109,
	"./Military/001-knife.png": 2110,
	"./Military/002-bomb-1.png": 2111,
	"./Military/003-radar.png": 2112,
	"./Military/004-medal-1.png": 2113,
	"./Military/005-launcher-1.png": 2114,
	"./Military/006-helmet.png": 2115,
	"./Military/007-chamber.png": 2116,
	"./Military/008-helicopter.png": 2117,
	"./Military/009-soldier.png": 2118,
	"./Military/010-lieutenant.png": 2119,
	"./Military/011-shotgun.png": 2120,
	"./Military/012-backpack.png": 2121,
	"./Military/013-bomb-detonation-1.png": 2122,
	"./Military/014-bomb-detonation.png": 2123,
	"./Military/015-fighter-plane.png": 2124,
	"./Military/016-dynamite.png": 2125,
	"./Military/017-first-aid-kit-1.png": 2126,
	"./Military/018-boat.png": 2127,
	"./Military/019-submarine.png": 2128,
	"./Military/020-compass.png": 2129,
	"./Military/021-insignia.png": 2130,
	"./Military/022-first-aid-kit.png": 2131,
	"./Military/023-placeholder.png": 2132,
	"./Military/024-jet.png": 2133,
	"./Military/025-flag.png": 2134,
	"./Military/026-boots.png": 2135,
	"./Military/027-gas-mask.png": 2136,
	"./Military/028-bullet-1.png": 2137,
	"./Military/029-launcher.png": 2138,
	"./Military/030-satellite-dish.png": 2139,
	"./Military/031-parachute.png": 2140,
	"./Military/032-gun.png": 2141,
	"./Military/033-bulletproof.png": 2142,
	"./Military/034-swiss-army-knife.png": 2143,
	"./Military/035-bullet.png": 2144,
	"./Military/036-binoculars.png": 2145,
	"./Military/037-target.png": 2146,
	"./Military/038-walkie-talkie.png": 2147,
	"./Military/039-rank.png": 2148,
	"./Military/040-barbed.png": 2149,
	"./Military/041-bomb.png": 2150,
	"./Military/042-radiation.png": 2151,
	"./Military/043-chevron.png": 2152,
	"./Military/044-map.png": 2153,
	"./Military/045-medal.png": 2154,
	"./Military/046-tank.png": 2155,
	"./Military/047-tent.png": 2156,
	"./Military/048-dog-tags-military.png": 2157,
	"./Military/049-grenade.png": 2158,
	"./Military/050-badge.png": 2159,
	"./Multimedia/3d-glasses.png": 2160,
	"./Multimedia/antenna.png": 2161,
	"./Multimedia/camera-1.png": 2162,
	"./Multimedia/camera-2.png": 2163,
	"./Multimedia/camera-3.png": 2164,
	"./Multimedia/camera.png": 2165,
	"./Multimedia/cd.png": 2166,
	"./Multimedia/chat.png": 2167,
	"./Multimedia/clapperboard.png": 2168,
	"./Multimedia/cloud.png": 2169,
	"./Multimedia/compact-disc.png": 2170,
	"./Multimedia/dvd.png": 2171,
	"./Multimedia/equalizer.png": 2172,
	"./Multimedia/film.png": 2173,
	"./Multimedia/floppy-disk.png": 2174,
	"./Multimedia/game.png": 2175,
	"./Multimedia/ipod-shuffle.png": 2176,
	"./Multimedia/ipod.png": 2177,
	"./Multimedia/keyboard.png": 2178,
	"./Multimedia/loudspeaker-1.png": 2179,
	"./Multimedia/loudspeaker.png": 2180,
	"./Multimedia/memory-card.png": 2181,
	"./Multimedia/microphone-1.png": 2182,
	"./Multimedia/microphone.png": 2183,
	"./Multimedia/mobile-phone.png": 2184,
	"./Multimedia/modem.png": 2185,
	"./Multimedia/negative-film.png": 2186,
	"./Multimedia/negative.png": 2187,
	"./Multimedia/next-track.png": 2188,
	"./Multimedia/pause.png": 2189,
	"./Multimedia/photos.png": 2190,
	"./Multimedia/play.png": 2191,
	"./Multimedia/previous-track.png": 2192,
	"./Multimedia/radio.png": 2193,
	"./Multimedia/rec.png": 2194,
	"./Multimedia/speaker.png": 2195,
	"./Multimedia/stop.png": 2196,
	"./Multimedia/tablet.png": 2197,
	"./Multimedia/tv-1.png": 2198,
	"./Multimedia/tv.png": 2199,
	"./Multimedia/web-cam.png": 2200,
	"./Office/adhesive-tape.png": 2201,
	"./Office/bookshelf.png": 2202,
	"./Office/box.png": 2203,
	"./Office/briefcase.png": 2204,
	"./Office/business-card.png": 2205,
	"./Office/cabinet.png": 2206,
	"./Office/calculator.png": 2207,
	"./Office/calendar.png": 2208,
	"./Office/clipboard.png": 2209,
	"./Office/clock.png": 2210,
	"./Office/coffee-cup.png": 2211,
	"./Office/computer.png": 2212,
	"./Office/copy-machine.png": 2213,
	"./Office/documents.png": 2214,
	"./Office/fax.png": 2215,
	"./Office/folder-1.png": 2216,
	"./Office/folder-2.png": 2217,
	"./Office/folder.png": 2218,
	"./Office/garbage.png": 2219,
	"./Office/headphones.png": 2220,
	"./Office/highlighter.png": 2221,
	"./Office/hole-puncher.png": 2222,
	"./Office/id-card.png": 2223,
	"./Office/lamp.png": 2224,
	"./Office/laptop.png": 2225,
	"./Office/letters.png": 2226,
	"./Office/mail.png": 2227,
	"./Office/mouse.png": 2228,
	"./Office/mug.png": 2229,
	"./Office/note.png": 2230,
	"./Office/notebook-1.png": 2231,
	"./Office/notebook.png": 2232,
	"./Office/office-chair.png": 2233,
	"./Office/paper-shredder.png": 2234,
	"./Office/pen.png": 2235,
	"./Office/pencil-case.png": 2236,
	"./Office/pendrive.png": 2237,
	"./Office/plant.png": 2238,
	"./Office/presentation.png": 2239,
	"./Office/printer.png": 2240,
	"./Office/projector.png": 2241,
	"./Office/push-pin.png": 2242,
	"./Office/router.png": 2243,
	"./Office/rubber-stamp.png": 2244,
	"./Office/safebox.png": 2245,
	"./Office/stapler.png": 2246,
	"./Office/table.png": 2247,
	"./Office/telephone.png": 2248,
	"./Office/uniform.png": 2249,
	"./Office/webcam.png": 2250,
	"./Professions/astronaut.png": 2251,
	"./Professions/athlete.png": 2252,
	"./Professions/builder.png": 2253,
	"./Professions/carpenter.png": 2254,
	"./Professions/cashier.png": 2255,
	"./Professions/chef.png": 2256,
	"./Professions/chemist.png": 2257,
	"./Professions/clown.png": 2258,
	"./Professions/concierge.png": 2259,
	"./Professions/courier.png": 2260,
	"./Professions/detective.png": 2261,
	"./Professions/diver.png": 2262,
	"./Professions/dj.png": 2263,
	"./Professions/doctor.png": 2264,
	"./Professions/dyer.png": 2265,
	"./Professions/electrician.png": 2266,
	"./Professions/farmer.png": 2267,
	"./Professions/firefighter.png": 2268,
	"./Professions/fisherman.png": 2269,
	"./Professions/gardener.png": 2270,
	"./Professions/hairdresser.png": 2271,
	"./Professions/lumberjack.png": 2272,
	"./Professions/magician.png": 2273,
	"./Professions/maid.png": 2274,
	"./Professions/manager.png": 2275,
	"./Professions/mechanic.png": 2276,
	"./Professions/miner.png": 2277,
	"./Professions/nurse.png": 2278,
	"./Professions/painter.png": 2279,
	"./Professions/pensioner.png": 2280,
	"./Professions/personplaceholder.png": 218,
	"./Professions/photographer.png": 2281,
	"./Professions/pilot.png": 2282,
	"./Professions/plumber.png": 2283,
	"./Professions/policeman.png": 2284,
	"./Professions/politician.png": 2285,
	"./Professions/postman.png": 2286,
	"./Professions/priest.png": 2287,
	"./Professions/professor.png": 2288,
	"./Professions/programmer.png": 2289,
	"./Professions/sailor.png": 2290,
	"./Professions/secretary.png": 2291,
	"./Professions/showman.png": 2292,
	"./Professions/singer.png": 2293,
	"./Professions/soldier.png": 2294,
	"./Professions/stewardess.png": 2295,
	"./Professions/support.png": 2296,
	"./Professions/taxi-driver.png": 2297,
	"./Professions/teacher.png": 2298,
	"./Professions/waiter.png": 2299,
	"./Professions/writer.png": 2300,
	"./PublicTransport/Coach_Black.png": 2301,
	"./PublicTransport/Coach_Blue.png": 2302,
	"./PublicTransport/Coach_Green.png": 2303,
	"./PublicTransport/Coach_Grey.png": 2304,
	"./PublicTransport/Coach_Red.png": 2305,
	"./PublicTransport/Coach_Yellow.png": 2306,
	"./PublicTransport/CommuterBus_Black.png": 2307,
	"./PublicTransport/CommuterBus_Blue.png": 2308,
	"./PublicTransport/CommuterBus_Green.png": 2309,
	"./PublicTransport/CommuterBus_Grey.png": 2310,
	"./PublicTransport/CommuterBus_Red.png": 2311,
	"./PublicTransport/CommuterBus_Yellow.png": 2312,
	"./PublicTransport/Taxi_Black.png": 2313,
	"./PublicTransport/Taxi_Blue.png": 2314,
	"./PublicTransport/Taxi_Green.png": 2315,
	"./PublicTransport/Taxi_Grey.png": 2316,
	"./PublicTransport/Taxi_Red.png": 2317,
	"./PublicTransport/Taxi_Yellow.png": 2318,
	"./PublicTransport/TransitBus_Black.png": 2319,
	"./PublicTransport/TransitBus_Blue.png": 2320,
	"./PublicTransport/TransitBus_Green.png": 2321,
	"./PublicTransport/TransitBus_Grey.png": 2322,
	"./PublicTransport/TransitBus_Red.png": 2323,
	"./PublicTransport/TransitBus_Yellow.png": 2324,
	"./Safety/001-fire.png": 2325,
	"./Safety/002-umbrella.png": 2326,
	"./Safety/003-shield-1.png": 2327,
	"./Safety/004-lifebuoy.png": 2328,
	"./Safety/005-cone.png": 2329,
	"./Safety/006-eye.png": 2330,
	"./Safety/007-helmet.png": 2331,
	"./Safety/008-safety-belt.png": 2332,
	"./Safety/009-first-aid-kit.png": 2333,
	"./Safety/010-barbed-wire.png": 2334,
	"./Safety/011-shield.png": 2335,
	"./Safety/012-cctv-1.png": 2336,
	"./Safety/013-cctv.png": 2337,
	"./Safety/014-fire-alarm-1.png": 2338,
	"./Safety/015-hose.png": 2339,
	"./Safety/016-hydrant.png": 2340,
	"./Safety/017-flasher.png": 2341,
	"./Safety/018-kitchen-hood.png": 2342,
	"./Safety/019-air-compressor.png": 2343,
	"./Safety/020-gas-mask.png": 2344,
	"./Safety/021-carbon-monoxide.png": 2345,
	"./Safety/022-extinguisher.png": 2346,
	"./Safety/023-sprinkler.png": 2347,
	"./Safety/024-pull.png": 2348,
	"./Safety/025-fire-alarm.png": 2349,
	"./Safety/026-smoke-detector.png": 2350,
	"./Safety/027-safety-code.png": 2351,
	"./Safety/028-signal.png": 2352,
	"./Safety/029-strongbox.png": 2353,
	"./Safety/030-password.png": 2354,
	"./Safety/031-key.png": 2355,
	"./Safety/032-keyhole.png": 2356,
	"./Safety/033-exit-1.png": 2357,
	"./Safety/034-door.png": 2358,
	"./Safety/035-padlock-1.png": 2359,
	"./Safety/036-padlock.png": 2360,
	"./Safety/037-house.png": 2361,
	"./Safety/038-exit.png": 2362,
	"./Safety/039-bell.png": 2363,
	"./Safety/040-stop.png": 2364,
	"./Safety/041-radiation.png": 2365,
	"./Safety/042-forbidden.png": 2366,
	"./Safety/043-not-touch.png": 2367,
	"./Safety/044-no-smoking.png": 2368,
	"./Safety/045-no-fire.png": 2369,
	"./Safety/046-high-voltage.png": 2370,
	"./Safety/047-fire-sign.png": 2371,
	"./Safety/048-warning.png": 2372,
	"./Safety/049-bomb.png": 2373,
	"./Safety/050-antenna.png": 2374,
	"./Shipping/aeroplane.png": 2375,
	"./Shipping/barcode.png": 2376,
	"./Shipping/box-1.png": 2377,
	"./Shipping/box.png": 2378,
	"./Shipping/boxes.png": 2379,
	"./Shipping/calendar.png": 2380,
	"./Shipping/clipboard.png": 2381,
	"./Shipping/container.png": 2382,
	"./Shipping/delivery-1.png": 2383,
	"./Shipping/delivery-2.png": 2384,
	"./Shipping/delivery-3.png": 2385,
	"./Shipping/delivery-truck.png": 2386,
	"./Shipping/delivery.png": 2387,
	"./Shipping/envelope.png": 2388,
	"./Shipping/find.png": 2389,
	"./Shipping/fragile.png": 2390,
	"./Shipping/gift.png": 2391,
	"./Shipping/laptop.png": 2392,
	"./Shipping/package-1.png": 2393,
	"./Shipping/package-2.png": 2394,
	"./Shipping/package-3.png": 2395,
	"./Shipping/package-4.png": 2396,
	"./Shipping/package-5.png": 2397,
	"./Shipping/package-6.png": 2398,
	"./Shipping/package-7.png": 2399,
	"./Shipping/package.png": 2400,
	"./Shipping/route.png": 2401,
	"./Shipping/safety.png": 2402,
	"./Shipping/ship.png": 2403,
	"./Shipping/shipping.png": 2404,
	"./Shipping/smartphone.png": 2405,
	"./Shipping/stroller.png": 2406,
	"./Shipping/support.png": 2407,
	"./Shipping/train.png": 2408,
	"./Shipping/up.png": 2409,
	"./Shipping/warehouse-1.png": 2410,
	"./Shipping/warehouse-2.png": 2411,
	"./Shipping/warehouse.png": 2412,
	"./Shipping/weight.png": 2413,
	"./Shipping/worldwide.png": 2414,
	"./Tools/atomic.png": 2415,
	"./Tools/awl.png": 2416,
	"./Tools/axe.png": 2417,
	"./Tools/barrels.png": 2418,
	"./Tools/battery-1.png": 2419,
	"./Tools/battery.png": 2420,
	"./Tools/box.png": 2421,
	"./Tools/charging.png": 2422,
	"./Tools/chisel.png": 2423,
	"./Tools/clamp.png": 2424,
	"./Tools/coal.png": 2425,
	"./Tools/compass.png": 2426,
	"./Tools/cutter.png": 2427,
	"./Tools/driller.png": 2428,
	"./Tools/ecology.png": 2429,
	"./Tools/electric-car.png": 2430,
	"./Tools/electric-tower.png": 2431,
	"./Tools/eolic-energy.png": 2432,
	"./Tools/factory.png": 2433,
	"./Tools/faucet.png": 2434,
	"./Tools/file.png": 2435,
	"./Tools/gas-station.png": 2436,
	"./Tools/gas.png": 2437,
	"./Tools/glue.png": 2438,
	"./Tools/hammer-1.png": 2439,
	"./Tools/hammer-2.png": 2440,
	"./Tools/hammer.png": 2441,
	"./Tools/house.png": 2442,
	"./Tools/hydro-power.png": 2443,
	"./Tools/jigsaw.png": 2444,
	"./Tools/ladder.png": 2445,
	"./Tools/level.png": 2446,
	"./Tools/light-bulb.png": 2447,
	"./Tools/low-battery.png": 2448,
	"./Tools/marker.png": 2449,
	"./Tools/mat.png": 2450,
	"./Tools/measuring-tape.png": 2451,
	"./Tools/nail.png": 2452,
	"./Tools/needle.png": 2453,
	"./Tools/nut.png": 2454,
	"./Tools/oil-platform.png": 2455,
	"./Tools/paint-brush-1.png": 2456,
	"./Tools/paint-brush-2.png": 2457,
	"./Tools/paint-brush.png": 2458,
	"./Tools/paint-bucket.png": 2459,
	"./Tools/paint-palette.png": 2460,
	"./Tools/paint-roller.png": 2461,
	"./Tools/pantone.png": 2462,
	"./Tools/pencil.png": 2463,
	"./Tools/pliers-1.png": 2464,
	"./Tools/pliers-2.png": 2465,
	"./Tools/pliers.png": 2466,
	"./Tools/plug.png": 2467,
	"./Tools/power-button.png": 2468,
	"./Tools/power-plant.png": 2469,
	"./Tools/rain.png": 2470,
	"./Tools/recycle.png": 2471,
	"./Tools/renewable-energy-1.png": 2472,
	"./Tools/renewable-energy.png": 2473,
	"./Tools/ruler-1.png": 2474,
	"./Tools/ruler.png": 2475,
	"./Tools/save-energy.png": 2476,
	"./Tools/saw-1.png": 2477,
	"./Tools/saw.png": 2478,
	"./Tools/scissors.png": 2479,
	"./Tools/screw.png": 2480,
	"./Tools/screwdriver.png": 2481,
	"./Tools/set-square.png": 2482,
	"./Tools/shovel-1.png": 2483,
	"./Tools/shovel.png": 2484,
	"./Tools/socket.png": 2485,
	"./Tools/solar-energy.png": 2486,
	"./Tools/spatula.png": 2487,
	"./Tools/tape.png": 2488,
	"./Tools/toolbox.png": 2489,
	"./Tools/usb-cable.png": 2490,
	"./Tools/workplace.png": 2491,
	"./Tools/wrench-1.png": 2492,
	"./Tools/wrench-2.png": 2493,
	"./Tools/wrench.png": 2494,
	"./Traffic/001-highway-1.png": 2495,
	"./Traffic/002-two-ways.png": 2496,
	"./Traffic/003-road-sign.png": 2497,
	"./Traffic/004-barrier.png": 2498,
	"./Traffic/005-right-arrow.png": 2499,
	"./Traffic/006-roundabout.png": 2500,
	"./Traffic/007-prohibition.png": 2501,
	"./Traffic/008-curves.png": 2502,
	"./Traffic/009-intersection-3.png": 2503,
	"./Traffic/010-caravan-1.png": 2504,
	"./Traffic/011-caravan.png": 2505,
	"./Traffic/012-highway.png": 2506,
	"./Traffic/013-traffic-sign-1.png": 2507,
	"./Traffic/014-traffic-sign.png": 2508,
	"./Traffic/015-warning-2.png": 2509,
	"./Traffic/016-gas-station.png": 2510,
	"./Traffic/017-turn-right-2.png": 2511,
	"./Traffic/018-coffee-shop.png": 2512,
	"./Traffic/019-bicycle-1.png": 2513,
	"./Traffic/020-bicycle.png": 2514,
	"./Traffic/021-bump.png": 2515,
	"./Traffic/022-intersection-2.png": 2516,
	"./Traffic/023-turn-1.png": 2517,
	"./Traffic/024-turn-right-1.png": 2518,
	"./Traffic/025-turn-left-1.png": 2519,
	"./Traffic/026-intersection-1.png": 2520,
	"./Traffic/027-intersection.png": 2521,
	"./Traffic/028-waiting.png": 2522,
	"./Traffic/029-horn.png": 2523,
	"./Traffic/030-narrow-road.png": 2524,
	"./Traffic/031-warning-1.png": 2525,
	"./Traffic/032-hill.png": 2526,
	"./Traffic/033-truck.png": 2527,
	"./Traffic/034-pedestrian-2.png": 2528,
	"./Traffic/035-pedestrian-1.png": 2529,
	"./Traffic/036-traffic-light.png": 2530,
	"./Traffic/037-turn.png": 2531,
	"./Traffic/038-slippery.png": 2532,
	"./Traffic/039-no-entry.png": 2533,
	"./Traffic/040-speed-limit.png": 2534,
	"./Traffic/041-humps.png": 2535,
	"./Traffic/042-falling-rocks.png": 2536,
	"./Traffic/043-pedestrian.png": 2537,
	"./Traffic/044-turn-right.png": 2538,
	"./Traffic/045-turn-left.png": 2539,
	"./Traffic/046-u-turn.png": 2540,
	"./Traffic/047-warning.png": 2541,
	"./Traffic/048-no-parking.png": 2542,
	"./Traffic/049-parking.png": 2543,
	"./Traffic/050-danger.png": 2544,
	"./Trailers/BoxTrailer_Black.png": 2545,
	"./Trailers/BoxTrailer_Blue.png": 2546,
	"./Trailers/BoxTrailer_Green.png": 2547,
	"./Trailers/BoxTrailer_Grey.png": 2548,
	"./Trailers/BoxTrailer_Red.png": 2549,
	"./Trailers/BoxTrailer_Yellow.png": 2550,
	"./Trailers/Caravan_Black.png": 2551,
	"./Trailers/Caravan_Blue.png": 2552,
	"./Trailers/Caravan_Green.png": 2553,
	"./Trailers/Caravan_Grey.png": 2554,
	"./Trailers/Caravan_Red.png": 2555,
	"./Trailers/Caravan_Yellow.png": 2556,
	"./Trailers/FullTrailer_Black.png": 2557,
	"./Trailers/FullTrailer_Blue.png": 2558,
	"./Trailers/FullTrailer_Green.png": 2559,
	"./Trailers/FullTrailer_Grey.png": 2560,
	"./Trailers/FullTrailer_Red.png": 2561,
	"./Trailers/FullTrailer_Yellow.png": 2562,
	"./Trailers/SuperSilentGeneratorTrailer_Black.png": 2563,
	"./Trailers/SuperSilentGeneratorTrailer_Blue.png": 2564,
	"./Trailers/SuperSilentGeneratorTrailer_Green.png": 2565,
	"./Trailers/SuperSilentGeneratorTrailer_Grey.png": 2566,
	"./Trailers/SuperSilentGeneratorTrailer_Red.png": 2567,
	"./Trailers/SuperSilentGeneratorTrailer_Yellow.png": 2568,
	"./Trailers/TankerTrailer_Black.png": 2569,
	"./Trailers/TankerTrailer_Blue.png": 2570,
	"./Trailers/TankerTrailer_Green.png": 2571,
	"./Trailers/TankerTrailer_Grey.png": 2572,
	"./Trailers/TankerTrailer_Red.png": 2573,
	"./Trailers/TankerTrailer_Yellow.png": 2574,
	"./Trailers/TravelTrailer_Black.png": 2575,
	"./Trailers/TravelTrailer_Blue.png": 2576,
	"./Trailers/TravelTrailer_Green.png": 2577,
	"./Trailers/TravelTrailer_Grey.png": 2578,
	"./Trailers/TravelTrailer_Red.png": 2579,
	"./Trailers/TravelTrailer_Yellow.png": 2580,
	"./Trailers/WaterBowserTrailer_Black.png": 2581,
	"./Trailers/WaterBowserTrailer_Blue.png": 2582,
	"./Trailers/WaterBowserTrailer_Green.png": 2583,
	"./Trailers/WaterBowserTrailer_Grey.png": 2584,
	"./Trailers/WaterBowserTrailer_Red.png": 2585,
	"./Trailers/WaterBowserTrailer_Yellow.png": 2586,
	"./Transportation/aeroplane.png": 2587,
	"./Transportation/airplane.png": 2588,
	"./Transportation/auto-ricksaw.png": 2589,
	"./Transportation/bike.png": 2590,
	"./Transportation/boat.png": 2591,
	"./Transportation/bus-1.png": 2592,
	"./Transportation/bus.png": 2593,
	"./Transportation/cable-car-cabin.png": 2594,
	"./Transportation/car-1.png": 2595,
	"./Transportation/car-2.png": 2596,
	"./Transportation/car-3.png": 2597,
	"./Transportation/car.png": 2598,
	"./Transportation/catamaran.png": 2599,
	"./Transportation/chairlift.png": 2600,
	"./Transportation/classic-car.png": 2601,
	"./Transportation/helicopter.png": 2602,
	"./Transportation/hot-air-balloon.png": 2603,
	"./Transportation/jeep.png": 2604,
	"./Transportation/locomotive.png": 2605,
	"./Transportation/lorry.png": 2606,
	"./Transportation/minibus.png": 2607,
	"./Transportation/monorail.png": 2608,
	"./Transportation/motorbike.png": 2609,
	"./Transportation/quad.png": 2610,
	"./Transportation/sailboat.png": 2611,
	"./Transportation/sailing-ship.png": 2612,
	"./Transportation/school-bus.png": 2613,
	"./Transportation/ship-1.png": 2614,
	"./Transportation/ship-2.png": 2615,
	"./Transportation/ship-3.png": 2616,
	"./Transportation/ship.png": 2617,
	"./Transportation/sidecar.png": 2618,
	"./Transportation/spaceship.png": 2619,
	"./Transportation/sportive-car.png": 2620,
	"./Transportation/submarine.png": 2621,
	"./Transportation/taxi-1.png": 2622,
	"./Transportation/taxi.png": 2623,
	"./Transportation/tractor.png": 2624,
	"./Transportation/train-1.png": 2625,
	"./Transportation/train-2.png": 2626,
	"./Transportation/train.png": 2627,
	"./Transportation/tram.png": 2628,
	"./Transportation/tricycle.png": 2629,
	"./Transportation/trolleybus.png": 2630,
	"./Transportation/truck.png": 2631,
	"./Transportation/ufo.png": 2632,
	"./Transportation/underground.png": 2633,
	"./Transportation/van-1.png": 2634,
	"./Transportation/van.png": 2635,
	"./Transportation/zeppelin.png": 2636,
	"./Trucks/BinTruck_Black.png": 2637,
	"./Trucks/BinTruck_Blue.png": 2638,
	"./Trucks/BinTruck_Green.png": 2639,
	"./Trucks/BinTruck_Grey.png": 2640,
	"./Trucks/BinTruck_Red.png": 2641,
	"./Trucks/BinTruck_Yellow.png": 2642,
	"./Trucks/FuelTankTruck_Black.png": 2643,
	"./Trucks/FuelTankTruck_Blue.png": 2644,
	"./Trucks/FuelTankTruck_Green.png": 2645,
	"./Trucks/FuelTankTruck_Grey.png": 2646,
	"./Trucks/FuelTankTruck_Red.png": 2647,
	"./Trucks/FuelTankTruck_Yellow.png": 2648,
	"./Trucks/HaulTruck_Black.png": 2649,
	"./Trucks/HaulTruck_Blue.png": 2650,
	"./Trucks/HaulTruck_Green.png": 2651,
	"./Trucks/HaulTruck_Grey.png": 2652,
	"./Trucks/HaulTruck_Red.png": 2653,
	"./Trucks/HaulTruck_Yellow.png": 2654,
	"./Trucks/LorryCab_Black.png": 2655,
	"./Trucks/LorryCab_Blue.png": 2656,
	"./Trucks/LorryCab_Green.png": 2657,
	"./Trucks/LorryCab_Grey.png": 2658,
	"./Trucks/LorryCab_Red.png": 2659,
	"./Trucks/LorryCab_Yellow.png": 2660,
	"./Trucks/LorryTrailer_Black.png": 2661,
	"./Trucks/LorryTrailer_Blue.png": 2662,
	"./Trucks/LorryTrailer_Green.png": 2663,
	"./Trucks/LorryTrailer_Grey.png": 2664,
	"./Trucks/LorryTrailer_Red.png": 2665,
	"./Trucks/LorryTrailer_Yellow.png": 2666,
	"./Trucks/Lorry_Black.png": 2667,
	"./Trucks/Lorry_Blue.png": 2668,
	"./Trucks/Lorry_Green.png": 2669,
	"./Trucks/Lorry_Grey.png": 2670,
	"./Trucks/Lorry_Red.png": 2671,
	"./Trucks/Lorry_Yellow.png": 2672,
	"./Trucks/PetroleumTankTruck_Black.png": 2673,
	"./Trucks/PetroleumTankTruck_Blue.png": 2674,
	"./Trucks/PetroleumTankTruck_Green.png": 2675,
	"./Trucks/PetroleumTankTruck_Grey.png": 2676,
	"./Trucks/PetroleumTankTruck_Red.png": 2677,
	"./Trucks/PetroleumTankTruck_Yellow.png": 2678,
	"./Trucks/SkipTruck_Black.png": 2679,
	"./Trucks/SkipTruck_Blue.png": 2680,
	"./Trucks/SkipTruck_Green.png": 2681,
	"./Trucks/SkipTruck_Grey.png": 2682,
	"./Trucks/SkipTruck_Red.png": 2683,
	"./Trucks/SkipTruck_Yellow.png": 2684,
	"./Trucks/TankerTruck_Black.png": 2685,
	"./Trucks/TankerTruck_Blue.png": 2686,
	"./Trucks/TankerTruck_Green.png": 2687,
	"./Trucks/TankerTruck_Grey.png": 2688,
	"./Trucks/TankerTruck_Red.png": 2689,
	"./Trucks/TankerTruck_Yellow.png": 2690,
	"./Trucks/TractorTrailer2_Black.png": 2691,
	"./Trucks/TractorTrailer2_Blue.png": 2692,
	"./Trucks/TractorTrailer2_Green.png": 2693,
	"./Trucks/TractorTrailer2_Grey.png": 2694,
	"./Trucks/TractorTrailer2_Red.png": 2695,
	"./Trucks/TractorTrailer2_Yellow.png": 2696,
	"./Trucks/TractorTrailer_Black.png": 2697,
	"./Trucks/TractorTrailer_Blue.png": 2698,
	"./Trucks/TractorTrailer_Green.png": 2699,
	"./Trucks/TractorTrailer_Grey.png": 2700,
	"./Trucks/TractorTrailer_Red.png": 2701,
	"./Trucks/TractorTrailer_Yellow.png": 2702,
	"./Trucks/TruckV_Black.png": 2703,
	"./Trucks/TruckV_Blue.png": 2704,
	"./Trucks/TruckV_Green.png": 2705,
	"./Trucks/TruckV_Grey.png": 2706,
	"./Trucks/TruckV_Red.png": 2707,
	"./Trucks/TruckV_Yellow.png": 2708,
	"./Trucks/Truck_Black.png": 2709,
	"./Trucks/Truck_Blue.png": 2710,
	"./Trucks/Truck_Green.png": 2711,
	"./Trucks/Truck_Grey.png": 2712,
	"./Trucks/Truck_Red.png": 2713,
	"./Trucks/Truck_Yellow.png": 2714,
	"./Watercraft/Barge_Black.png": 2715,
	"./Watercraft/Barge_Blue.png": 2716,
	"./Watercraft/Barge_Green.png": 2717,
	"./Watercraft/Barge_Grey.png": 2718,
	"./Watercraft/Barge_Red.png": 2719,
	"./Watercraft/Barge_Yellow.png": 2720,
	"./Watercraft/Boat_Black.png": 2721,
	"./Watercraft/Boat_Blue.png": 2722,
	"./Watercraft/Boat_Gray.png": 2723,
	"./Watercraft/Boat_Green.png": 2724,
	"./Watercraft/Boat_Red.png": 2725,
	"./Watercraft/Boat_Yellow.png": 2726,
	"./Watercraft/BulkCarrier_Black.png": 2727,
	"./Watercraft/BulkCarrier_Blue.png": 2728,
	"./Watercraft/BulkCarrier_Green.png": 2729,
	"./Watercraft/BulkCarrier_Grey.png": 2730,
	"./Watercraft/BulkCarrier_Red.png": 2731,
	"./Watercraft/BulkCarrier_Yellow.png": 2732,
	"./Watercraft/Motorboat_Black.png": 2733,
	"./Watercraft/Motorboat_Blue.png": 2734,
	"./Watercraft/Motorboat_Green.png": 2735,
	"./Watercraft/Motorboat_Grey.png": 2736,
	"./Watercraft/Motorboat_Red.png": 2737,
	"./Watercraft/Motorboat_Yellow.png": 2738,
	"./Watercraft/Sailboat_Black.png": 2739,
	"./Watercraft/Sailboat_Blue.png": 2740,
	"./Watercraft/Sailboat_Green.png": 2741,
	"./Watercraft/Sailboat_Grey.png": 2742,
	"./Watercraft/Sailboat_Red.png": 2743,
	"./Watercraft/Sailboat_Yellow.png": 2744,
	"./Watercraft/Tanker_Black.png": 2745,
	"./Watercraft/Tanker_Blue.png": 2746,
	"./Watercraft/Tanker_Green.png": 2747,
	"./Watercraft/Tanker_Grey.png": 2748,
	"./Watercraft/Tanker_Red.png": 2749,
	"./Watercraft/Tanker_Yellow.png": 2750,
	"./Watercraft/WaterMotorcycle_Black.png": 2751,
	"./Watercraft/WaterMotorcycle_Blue.png": 2752,
	"./Watercraft/WaterMotorcycle_Green.png": 2753,
	"./Watercraft/WaterMotorcycle_Grey.png": 2754,
	"./Watercraft/WaterMotorcycle_Red.png": 2755,
	"./Watercraft/WaterMotorcycle_Yellow.png": 2756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;